
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './list';




class Post extends Component {
    render() {
        return (
            <Switch>
                {/* <Route
                    path="/visitor/create"
                    render={props => <Create type='create' {...props} />}
                />
                <Route
                    path="/visitor/update/:slug"
                    render={props => <Create type='update' {...props} />}
                /> */}
                <Route
                    path="/visitor/list"
                    render={props => <List {...props} />}
                />
            </Switch>
        );
    }
}


export default Post